/* COCOMOO — theme interactions */
(function(){
  "use strict";
  var money = window.CocoMoo && window.CocoMoo.moneyFormat ? window.CocoMoo.moneyFormat : "${{amount}}";

  function formatMoney(cents){
    var value = (cents/100).toFixed(2);
    if(money.indexOf("{{amount_no_decimals}}") > -1){ value = Math.round(cents/100).toString(); }
    return money.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/g, value);
  }

  function $(s,c){ return (c||document).querySelector(s); }
  function $all(s,c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); }

  /* ---------- scrim ---------- */
  var scrim = $(".scrim");
  function openScrim(){ if(scrim) scrim.classList.add("is-open"); document.documentElement.style.overflow="hidden"; }
  function closeAll(){
    if(scrim) scrim.classList.remove("is-open");
    document.documentElement.style.overflow="";
    var mn=$(".mobile-nav"); if(mn) mn.classList.remove("is-open");
    var dr=$(".drawer"); if(dr) dr.classList.remove("is-open");
  }
  if(scrim) scrim.addEventListener("click", closeAll);
  document.addEventListener("keydown", function(e){ if(e.key==="Escape") closeAll(); });

  /* ---------- mobile nav ---------- */
  var burger=$("[data-burger]"), mnav=$(".mobile-nav");
  if(burger && mnav){
    burger.addEventListener("click", function(){ mnav.classList.add("is-open"); openScrim(); });
  }
  $all("[data-close-nav]").forEach(function(b){ b.addEventListener("click", closeAll); });

  /* ---------- announcement rotation ---------- */
  var msgs=$all(".announcement__msg");
  if(msgs.length>1){
    var i=0;
    setInterval(function(){
      msgs[i].classList.remove("is-active");
      i=(i+1)%msgs.length;
      msgs[i].classList.add("is-active");
    }, 4200);
  }

  /* ---------- scroll reveal (progressive enhancement; content visible by default) ---------- */
  var revealIO = ("IntersectionObserver" in window) ? new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.remove("reveal--pre"); revealIO.unobserve(en.target); } });
  },{ threshold:.08, rootMargin:"0px 0px -40px 0px" }) : null;

  function initReveal(root){
    if(!revealIO) return; /* no IO support: leave everything visible */
    var vh = window.innerHeight || document.documentElement.clientHeight;
    $all(".reveal", root).forEach(function(el){
      if(el.getAttribute("data-reveal-bound")) return;
      el.setAttribute("data-reveal-bound","1");
      if(el.getBoundingClientRect().top < vh * 0.9){ return; } /* at/near top: stay visible, no animation */
      el.classList.add("reveal--pre");
      revealIO.observe(el);
    });
  }

  initReveal(document);
  /* Shopify theme editor swaps sections without re-running scripts — re-init on its events */
  document.addEventListener("shopify:section:load", function(e){ initReveal(e.target); });
  document.addEventListener("shopify:section:select", function(e){ initReveal(e.target); });
  /* absolute safety net: never leave content hidden */
  setTimeout(function(){ $all(".reveal--pre").forEach(function(el){ el.classList.remove("reveal--pre"); }); }, 2500);

  /* ---------- quantity steppers ---------- */
  document.addEventListener("click", function(e){
    var btn=e.target.closest("[data-qty]");
    if(!btn) return;
    var input=btn.parentNode.querySelector("input");
    if(!input) return;
    var v=parseInt(input.value,10)||1;
    v += btn.getAttribute("data-qty")==="up" ? 1 : -1;
    if(v<1) v=1;
    input.value=v;
    input.dispatchEvent(new Event("change",{bubbles:true}));
  });

  /* ---------- PDP gallery ---------- */
  var mainImg=$("[data-pdp-main]");
  if(mainImg){
    $all("[data-pdp-thumb]").forEach(function(t){
      t.addEventListener("click", function(){
        mainImg.src=t.getAttribute("data-full");
        mainImg.srcset="";
        $all("[data-pdp-thumb]").forEach(function(x){ x.classList.remove("is-active"); });
        t.classList.add("is-active");
      });
    });
  }

  /* ---------- PDP variant selection ---------- */
  var vform=$("[data-product-form]");
  if(vform && window.CocoMoo && window.CocoMoo.variants){
    var variants=window.CocoMoo.variants;
    function currentOptions(){
      return $all("[data-option-index]", vform).map(function(group){
        var checked=group.querySelector("input:checked");
        return checked ? checked.value : null;
      });
    }
    function updateVariant(){
      var opts=currentOptions();
      var match=variants.find(function(v){
        return v.options.every(function(o,idx){ return o===opts[idx]; });
      });
      var idInput=$("[data-variant-id]", vform);
      var priceEl=$("[data-pdp-price]");
      var atc=$("[data-atc]", vform);
      if(match){
        if(idInput) idInput.value=match.id;
        if(atc){ atc.disabled=!match.available; atc.querySelector("[data-atc-text]").textContent = match.available ? "Add to bag" : "Sold out"; }
        if(priceEl){
          var html='<span class="price--now">'+formatMoney(match.price)+'</span>';
          if(match.compare_at_price && match.compare_at_price>match.price){
            html='<span class="price--was">'+formatMoney(match.compare_at_price)+'</span>'+html;
          }
          priceEl.innerHTML=html;
        }
      } else if(atc){ atc.disabled=true; atc.querySelector("[data-atc-text]").textContent="Unavailable"; }
    }
    $all("input[type=radio]", vform).forEach(function(r){ r.addEventListener("change", updateVariant); });
    updateVariant();
  }

  /* ---------- cart drawer ---------- */
  var drawer=$(".drawer");
  function openDrawer(){ if(drawer){ drawer.classList.add("is-open"); openScrim(); } }
  $all("[data-cart-toggle]").forEach(function(b){
    b.addEventListener("click", function(e){ e.preventDefault(); refreshCart().then(openDrawer); });
  });

  function setCount(n){ $all("[data-cart-count]").forEach(function(el){ el.textContent=n; el.style.display = n>0 ? "" : "none"; }); }

  function lineHTML(item){
    var img = item.image ? '<img src="'+item.image.replace(/(\.[a-z]+)(\?|$)/,'_160x$1$2')+'" alt="'+(item.product_title||"")+'">' : '';
    var opts = (item.options_with_values||[]).filter(function(o){ return o.value!=="Default Title"; })
                 .map(function(o){ return o.value; }).join(" / ");
    var planName = (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan)
                   ? item.selling_plan_allocation.selling_plan.name : "";
    var planTag = planName ? '<div class="d-line__plan">'+planName+'</div>' : '';
    return '<div class="d-line" data-key="'+item.key+'">'+
      '<div class="d-line__img">'+img+'</div>'+
      '<div><div class="d-line__title">'+item.product_title+'</div>'+
      (opts?'<div class="d-line__meta">'+opts+'</div>':'')+
      planTag+
      '<div class="d-line__meta">Qty '+
        '<span class="qty" style="transform:scale(.82);transform-origin:left;display:inline-flex;vertical-align:middle">'+
          '<button type="button" data-qty="down" data-line-key="'+item.key+'">–</button>'+
          '<input type="text" value="'+item.quantity+'" data-line-input="'+item.key+'" inputmode="numeric">'+
          '<button type="button" data-qty="up" data-line-key="'+item.key+'">+</button>'+
        '</span></div>'+
      '<button class="d-line__remove" data-remove="'+item.key+'">Remove</button></div>'+
      '<div class="d-line__price">'+formatMoney(item.final_line_price)+'</div>'+
    '</div>';
  }

  function render(cart){
    setCount(cart.item_count);
    var body=$("[data-drawer-body]");
    if(!body) return;
    if(cart.item_count===0){
      body.innerHTML='<div class="drawer__empty"><p>Your bag is empty.</p><a class="btn btn--ghost" href="/collections/all">Shop all scents</a></div>';
    } else {
      body.innerHTML=cart.items.map(lineHTML).join("");
    }
    var sub=$("[data-drawer-subtotal]"); if(sub) sub.textContent=formatMoney(cart.total_price);
    // free shipping progress
    var ship=$("[data-ship-bar]"), shiptext=$("[data-ship-text]");
    var threshold=(window.CocoMoo && window.CocoMoo.freeShip)||6500;
    if(ship){
      var pct=Math.min(100,(cart.total_price/threshold)*100);
      ship.style.width=pct+"%";
      if(shiptext){
        if(cart.total_price>=threshold){ shiptext.textContent="You've unlocked free U.S. shipping."; }
        else { shiptext.textContent="You're "+formatMoney(threshold-cart.total_price)+" away from free shipping."; }
      }
    }
    var foot=$("[data-drawer-foot]"); if(foot) foot.style.display = cart.item_count>0 ? "" : "none";
  }

  function refreshCart(){
    return fetch("/cart.js",{headers:{"Accept":"application/json"}}).then(function(r){return r.json();}).then(function(c){ render(c); return c; });
  }

  function change(key, qty){
    return fetch("/cart/change.js",{
      method:"POST", headers:{"Content-Type":"application/json","Accept":"application/json"},
      body:JSON.stringify({ id:key, quantity:qty })
    }).then(function(r){return r.json();}).then(render);
  }

  document.addEventListener("click", function(e){
    var rm=e.target.closest("[data-remove]");
    if(rm){ change(rm.getAttribute("data-remove"), 0); return; }
    var step=e.target.closest("[data-line-key]");
    if(step){
      var key=step.getAttribute("data-line-key");
      var input=$('[data-line-input="'+key+'"]');
      var v=parseInt(input.value,10)||1;
      v += step.getAttribute("data-qty")==="up" ? 1 : -1;
      if(v<0) v=0;
      change(key, v);
    }
  });

  /* ---------- AJAX add to cart ---------- */
  $all("[data-product-form]").forEach(function(form){
    form.addEventListener("submit", function(e){
      e.preventDefault();
      var btn=form.querySelector("[data-atc]");
      var orig = btn ? btn.querySelector("[data-atc-text]").textContent : "";
      if(btn){ btn.disabled=true; btn.querySelector("[data-atc-text]").textContent="Adding…"; }
      fetch("/cart/add.js",{
        method:"POST", headers:{"Accept":"application/json"}, body:new FormData(form)
      }).then(function(r){ return r.json(); }).then(function(){
        return refreshCart();
      }).then(function(){
        if(btn){ btn.disabled=false; btn.querySelector("[data-atc-text]").textContent=orig; }
        openDrawer();
      }).catch(function(){
        if(btn){ btn.disabled=false; btn.querySelector("[data-atc-text]").textContent=orig; }
        form.submit();
      });
    });
  });

  /* ---------- quick add (grid) ---------- */
  $all("[data-quick-add]").forEach(function(btn){
    btn.addEventListener("click", function(e){
      e.preventDefault();
      var id=btn.getAttribute("data-quick-add");
      btn.disabled=true; var t=btn.textContent; btn.textContent="Adding…";
      fetch("/cart/add.js",{ method:"POST", headers:{"Content-Type":"application/json","Accept":"application/json"},
        body:JSON.stringify({ id:id, quantity:1 }) })
        .then(function(r){return r.json();}).then(refreshCart).then(function(){
          btn.disabled=false; btn.textContent=t; openDrawer();
        }).catch(function(){ btn.disabled=false; btn.textContent=t; });
    });
  });

  // keep count fresh on load
  refreshCart();
})();

/* ---------- hero slideshow ---------- */
(function(){
  var root = document.querySelector("[data-slides]");
  if(!root) return;
  var slides = Array.prototype.slice.call(root.querySelectorAll("[data-slide]"));
  var dots   = Array.prototype.slice.call(root.querySelectorAll("[data-slide-dot]"));
  if(slides.length < 2) return;
  var i = 0, timer = null;

  function go(n){
    i = (n + slides.length) % slides.length;
    slides.forEach(function(s, x){ s.classList.toggle("is-active", x === i); });
    dots.forEach(function(d, x){ d.classList.toggle("is-active", x === i); });
  }
  function next(){ go(i + 1); }
  function prev(){ go(i - 1); }
  function restart(){ if(timer){ clearInterval(timer); timer = setInterval(next, 6000); } }

  var nextBtn = root.querySelector("[data-slide-next]");
  var prevBtn = root.querySelector("[data-slide-prev]");
  if(nextBtn) nextBtn.addEventListener("click", function(){ next(); restart(); });
  if(prevBtn) prevBtn.addEventListener("click", function(){ prev(); restart(); });
  dots.forEach(function(d){
    d.addEventListener("click", function(){ go(parseInt(d.getAttribute("data-slide-dot"), 10) || 0); restart(); });
  });

  if(!window.matchMedia("(prefers-reduced-motion: reduce)").matches){
    timer = setInterval(next, 6000);
  }
})();

